<template>
  <div class="selection-a-f-d-message-overview">

    <div class="panel-footer" v-if="hasAfdMessages || filterActive || loading">
      <div class="per-page">
        Per pagina
        <a-select v-model="perPage" @change="onPerPageChange" style="width: 70px;">
          <a-select-option v-for="(option, index) in perPageOptions" :key="index" :value="option">
            {{ option }}
          </a-select-option>
        </a-select>

        <!--        <filter-component-->
        <!--            :static-search="staticSearch"-->
        <!--            @filter-request="getFilteredAfdMessages($event)"-->
        <!--        />-->

      </div>
    </div>
    <div class="panel-footer" v-if="displayPagination">
      <laravel-pagination
          :data="currentRequestData"
          @pagination-change-page="loadPage"
      ></laravel-pagination>
    </div>

    <div class="table-responsive">

      <table class="table table-striped" :class="{ loading: loading }">
        <thead>
        <tr>
          <th>Berichtnummer</th>
          <th>Polisnummer</th>
          <th>Maatschappij</th>
          <th>Branche</th>
          <th>Omschrijving</th>
          <th>Ontvangen op</th>
          <th>
            <!-- Toon bericht -->
          </th>
        </tr>
        </thead>

        <SkeletonLoader v-if="loading" :rows="perPage" :columns="7"/>

        <tbody v-else>
        <template v-if="hasAfdMessages">
          <rowComponent v-for="afdMessage in afdMessages" :key="afdMessage.id" :afdMessage="afdMessage"/>
        </template>
        <tr v-else>
          <td colspan="7">
            Geen zoekresultaten
            <span v-if="filterActive"> die voldoen aan de actieve filter(s).</span>
          </td>
        </tr>
        </tbody>
      </table>

    </div>

    <div class="panel-footer" v-if="displayPagination">
      <laravel-pagination
          :data="currentRequestData"
          @pagination-change-page="loadPage"
      ></laravel-pagination>
    </div>
  </div>
</template>

<script>
import staticSelectionApi from '~/api/static_selection';
// import RowComponent from './RowComponent';
// import FilterComponent from "./FilterComponent";
import SkeletonLoader from '../components/SkeletonLoader';

export default {
  name: "SelectionAFDMessageOverviewComponent",
  components: {
    // RowComponent,
    // FilterComponent,
    SkeletonLoader
  },
  props: {
    staticSearch: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      perPageOptions: [15, 30, 50],
      afdMessages: [],
      loading: false,
      page: 1,
      perPage: 15,
      orderBy: 'datetime',
      order: 'desc',
      filter: {},
      currentPage: null,
      currentRequestData: null,
      reloadTimeout: null,
    }
  },
  mounted() {
    this.loadPage();
  },
  methods: {
    getFilteredAfdMessages(params) {
      this.filter = params;
      this.loadPage(this.page, true);
    },
    loadPage(page = 1, forceReload = false) {
      if (page === this.currentPage && forceReload !== true) {
        return;
      }

      this.loading = true;

      staticSelectionApi.paginateByStaticSearch(
          this.staticSearch.key,
          page,
          this.perPage,
          this.orderBy,
          this.order,
          ['customer', 'customer.addresses', 'agency'],
          this.filter,
      ).then((response) => {
        this.afdMessages = response.data;
        this.currentRequestData = response;
        this.currentPage = page;
      }).catch((error) => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: `Het is niet gelukt om de selecties voor ${this.staticSearch.name} te laden.`,
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    onOrderByChange(orderBy, order) {
      this.orderBy = orderBy;
      this.order = order;
      this.loadPage(this.currentPage, true);
    },
    onPerPageChange(value) {
      if (this.currentTotalItemCount !== null) {
        let newTotalPages = Math.ceil(this.currentTotalItemCount / value);

        if (this.currentPage > newTotalPages) {
          this.page = this.currentPage = 1;
        } else {
          this.page = this.currentPage;
        }
      } else {
        this.page = 1;
      }

      this.reloadPage();
    },
    reloadPage(page = null) {
      if (page === null) {
        this.page = this.currentPage;
      } else {
        this.page = page;
      }

      if (this.reloadTimeout !== null) {
        clearTimeout(this.reloadTimeout);
      }

      this.reloadTimeout = setTimeout(() => {
        this.loadPage(this.page, true);
      }, 200);
    },
  },
  computed: {
    displayPagination() {
      return this.isLoaded && this.hasAfdMessages && this.hasPages && typeof this.currentRequestData.meta !== "undefined";
    },
    currentTotalItemCount() {
      return (
          this.currentRequestData !== null
          && typeof this.currentRequestData.meta !== "undefined"
          && this.currentRequestData.meta !== null
          && typeof this.currentRequestData.meta.pagination !== "undefined"
          && this.currentRequestData.meta.pagination !== null
          && typeof this.currentRequestData.meta.pagination.total !== "undefined"
          && this.currentRequestData.meta.pagination.total !== null
      )
          ? this.currentRequestData.meta.pagination.total
          : null;
    },
    filterActive() {
      if (Object.entries(this.filter)) {
        for (const [key, value] of Object.entries(this.filter)) {
          if (value.length > 0) return true;
        }
      }
      return false;
    },
    hasAfdMessages() {
      return this.afdMessages.length > 0;
    },
    hasPages() {
      return this.isLoaded && this.currentRequestData.meta.pagination.total_pages > 1;
    },
    isLoaded() {
      return this.currentRequestData !== null;
    },
  }
}
</script>

<style scoped>
table > tbody.loading {
  opacity: 0.5;
}

.loading {
  opacity: 0.5;
}
</style>